import { Injectable } from '@angular/core';
import { AnalyticsBrowser } from '@segment/analytics-next';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EOLService {
  private analytics: AnalyticsBrowser | undefined;

  constructor() {
    this.initialiseAnalytics();
  }

  initialiseAnalytics(): void {
    // Do nothing if the service has already been setup successfully once before.
    if (this.analytics) return;

    this.analytics = this.loadAnalyticsBrowser();

    if (!this.analytics) {
      console.warn('Initialisation of SegmentAnalyticsService failed.');
    }
  }

  private loadAnalyticsBrowser(): AnalyticsBrowser | undefined {
    if (Object.getOwnPropertyDescriptor(environment, 'segmentConfig')) {
      return AnalyticsBrowser.load(
        {
          writeKey: environment['segmentConfig'].writeKey,
          cdnURL: environment['segmentConfig'].cdnUrl(),
        },
        {
          integrations: {
            'Segment.io': {
              apiHost: environment['segmentConfig'].apiHost(),
              protocol: 'https',
            },
            'Google Tag Manager': { enabled: false },
          },
        },
      );
    }
  }

  track(event: string): void {
    if (this.analytics) {
      this.analytics.track(event);
    }
  }
}
